import { YOUTUBE_TYPES } from "../actions/user/YoutubeAction";

const initialState = {
    loading: false,
    influencer_details: {},
    channelId: ''
}

const youtubeReducer = (state = initialState, action) => {
    switch (action.type) {
        case YOUTUBE_TYPES.LOADING:
            return {
                ...state,
                loading: action.payload.loading
            }

        case YOUTUBE_TYPES.INFLUENCER_DETAILS:
            return {
                ...state,
                influencer_details: action.payload.influencer_details
            }

        case YOUTUBE_TYPES.CHANNELID:
            return {
                ...state,
                channelId: action.payload.channelId
            }

        default:
            return state;
    }
}


export default youtubeReducer;
